module.exports = __webpack_public_path__ + "static/media/clientsActive.59e4a951.svg";